<template>
  <div class="market-menu" @mouseenter="enter()" @mouseleave="leave()">
    <img src="../../assets/images/yingyong.png" alt="" class="yyicon" />
    <span
      >应用服务
      <i class="el-icon-arrow-down"></i>
    </span>
    <ul class="marketing" id="marketing">
      <template v-for="item in subSystems">
        <li @click="toSystem(item.perms, item.url)" :key="item.perms">
          <div>
            <img
              :src="
                require(`../../assets/images/${item.img}`)
              "
              alt=""
              class="market-yx"
            />
          </div>
          <div class="menu-text">{{ item.name }}</div>
        </li>
      </template>
      <!--      <li @click="toSystem('WINE')">-->
      <!--        <div><img src="/static/img/wine.png"-->
      <!--                  alt=""-->
      <!--                  class="market-yx" />-->
      <!--        </div>-->
      <!--        <div class="menu-text">品鉴酒管控</div>-->
      <!--      </li>-->
      <!--      <li @click="toSystem('WINE')">-->
      <!--        <div><img src="/static/img/wine.png"-->
      <!--                  alt=""-->
      <!--                  class="market-yx" />-->
      <!--        </div>-->
      <!--        <div class="menu-text">品鉴酒管控</div>-->
      <!--      </li>-->
      <li>
        <div>
          <img src="/static/img/gengduo.png" alt="" class="market-yx" />
        </div>
        <div class="menu-text">期待更多</div>
      </li>
    </ul>
  </div>
</template>

<script>
import {
  ENVCONFIG,
  GUOFEN_CLUB_URL,
  YJ_LM_URL,
  LX_HY_URL,
  YINJIU_GUWEN,
  GUOTAI_FENGTAN,
  FRONTEND_MEMBER_URL,
  FRONTEND_MARKET_URL,
  YX_HOST_API,
  YD_HOST_API,
  FRONTEND_WINE_URL,
  YS_HOST_API,
  ZD_GL_URL
} from '@/api/local.js';
import { toYuntuan } from '@/api/customer.js';
import Qs from 'qs';

export default {
  data() {
    return {
      subSystems: [
        {
          name: '经销商联谊会',
          perms: 'LX_HY_URL',
          img: 'yunshang.png',
          url: LX_HY_URL
        },
        // 修改名字为饮酒联盟
        {
          name: '饮酒联盟',
          perms: 'YJ_LM_URL',
          img: 'yundian.png',
          url: YJ_LM_URL
        },
        {
          name: '终端管理',
          perms: 'ZD_GL_URL',
          img: 'terminal.png',
          url: ZD_GL_URL
        },
        {
          name: '饮品顾问',
          perms: 'YINJIU_GUWEN',
          img: 'yinjiuguwen.png',
          url: YINJIU_GUWEN
        },
        {
          name: '国粉俱乐部',
          perms: 'FRONTEND_MEMBER_URL',
          img: 'yunzhong.png',
          url: GUOFEN_CLUB_URL
        },
        {
          name: '封坛',
          perms: 'GUOTAI_FENGTAN',
          img: 'fengtan.png',
          url: GUOTAI_FENGTAN
        },
        {
          name: '智能布奖',
          perms: 'ZY_MARKET',
          img: 'zhinengbujiang.png',
          url: FRONTEND_MARKET_URL
        },
      ],
      
      paramsType: 'outside'
    };
  },
  methods: {
    leave() {
      document.getElementById('marketing').style.display = 'none';
    },
    enter() {
      document.getElementById('marketing').style.display = 'block';
    },
    // 跳转到不同的系统
    toSystem(systemCode, systemUrl) {
      const userInfo = Lockr.get('userInfo');
      const authKey = Lockr.get('authKey');
      const sessionId = Lockr.get('sessionId');
      // 跳到智能布奖
      if (systemCode === 'ZY_MARKET') {
        const params = {
          id: userInfo.id,
          authKey,
          sessionId,
          userLogo: userInfo.logo_url,
          nickName: userInfo.username,
          userHeadImg: userInfo.avatar,
        };
        const url = `${systemUrl}home/index?${Qs.stringify(
          params
        )}`;
        console.log(url)
        window.open(url, '_blank');
      }
      // 跳到云众（会员中心）
      if (systemCode === 'ZY_MEMBER') {
        const params = {
          userInfo,
          authKey,
          sessionId,
        };
        const url = `${systemUrl}index?${Qs.stringify(params)}`;
        console.log(url)
        window.open(url, '_blank');
      }
      // 跳到云团系统
      if (systemCode === 'ZY_GROUP') {
        let objToStr = JSON.stringify('userInfo');
        toYuntuan(authKey, sessionId, objToStr);
      }
      // 跳到云商
      if (systemCode === 'CLOUD_BUSINESS') {
        if (userInfo.id === 14 || userInfo.id === '14') {
          router.push('/home/yxqa');
          const url = this.$router.resolve({ path: '/home/yxwelcome' });
          console.log(url.href)
          window.open(url.href, '_blank');
        } else {
          const params = {
            authKey,
            sessionId,
            userInfo,
            type: this.paramsType,
          };
          const url = `${systemUrl}?${Qs.stringify(params)}`;
          console.log(url)
          window.open(url, '_blank');
        }
      }
      // 跳到云销(CLOUD_MARKET) 或者云店(CLOUD_SHOP)
      if (systemCode === 'CLOUD_MARKET' || systemCode === 'CLOUD_SHOP') {
        const params = {
          authKey,
          sessionId,
          userInfo,
          type: this.paramsType,
        };
        const url = `${systemUrl}?${Qs.stringify(params)}`;
        console.log(url)
        window.open(url, '_blank');
      }
      // 跳转到品鉴酒
      if (systemCode === 'SAVOUR_WINE') {
        const params = {
          id: userInfo.id,
          authKey,
          sessionId,
          userLogo: userInfo.logo_url,
          nickName: userInfo.username,
          userHeadImg: userInfo.avatar,
        };
        const url = `${systemUrl}wine/index?${Qs.stringify(
          params
        )}`;
        console.log(url)
        window.open(url, '_blank');
      }
      // 跳到饮酒顾问系统
      if (systemCode === 'YINJIU_GUWEN') {
        const params = {
          userInfo,
          authKey,
          sessionId,
        };
        const url = `${systemUrl}?${Qs.stringify(params)}`;
        console.log(url)
        window.open(url, '_blank');
      }
      // 跳到国粉俱乐部（会员中心）
      if (systemCode === 'FRONTEND_MEMBER_URL') {
        const params = {
          userInfo,
          authKey,
          sessionId,
        };
        const url = `${systemUrl}index?${Qs.stringify(params)}`;
        console.log(url)
        window.open(url, '_blank');
      }
      // 跳到领袖会
      if (systemCode === 'LX_HY_URL') {
        if (userInfo.id === 14 || userInfo.id === '14') {
          router.push('/home/yxqa');
          const url = this.$router.resolve({ path: '/home/yxwelcome' });
          console.log(url.href)
          window.open(url.href, '_blank');
        } else {
          const params = {
            authKey,
            sessionId,
            userInfo,
            type: this.paramsType,
          };
          const url = `${systemUrl}?${Qs.stringify(params)}`;
          console.log('领袖会==', url);
          window.open(url, '_blank');
        }
      }
      // 饮酒联盟
      if (systemCode === 'YJ_LM_URL') {
        const params = {
          authKey,
          sessionId,
          userInfo,
          type: this.paramsType,
        };
        const url = `${systemUrl}?${Qs.stringify(params)}`;
        console.log('联盟==', url);
        window.open(url, '_blank');
      }
      // 终端管理
      if (systemCode === 'ZD_GL_URL') {
        const params = {
          authKey,
          sessionId,
          userInfo,
          type: this.paramsType,
        };
        const url = `${systemUrl}/user?${Qs.stringify(params)}`;
        console.log('终端管理==', url);
        window.open(url, '_blank');
      }
      // 跳到封坛
      if (systemCode === 'GUOTAI_FENGTAN') {
        const params = {
          id: userInfo.id,
          authKey,
          sessionId,
          userLogo: userInfo.logo_url,
          nickName: userInfo.username,
          userHeadImg: userInfo.avatar,
        };
        const url = `${systemUrl}?${Qs.stringify(params)}`;
        console.log(url)
        window.open(url, '_blank');
      }
    }
  },
  mounted() {
    // this.subSystems = Lockr.get('subSystems')
  },
};
</script>


<style scoped>
.market-menu ul,
.market-menu li {
  margin: 0;
  padding: 0;
  list-style: none;
}
.market-menu {
  float: right;
  margin-right: 10px;
  cursor: pointer;
  margin-right: 15px;
  position: relative;
}
.market-menu img {
  width: 24px;
  height: 19px;
  margin: 0 5px 0 0;
  vertical-align: middle;
}
.yyicon {
  margin: 0 5px 7px 0 !important;
}
.market-menu span {
  color: #fff;
  font-size: 18px;
}
.marketing {
  display: none;
  width: 388px;
  min-height: 150px;
  padding: 20px !important;
  background: #fff;
  position: absolute;
  left: -129px;
  top: 61px;
  -webkit-box-shadow: #666 0px 0px 10px;
  -moz-box-shadow: #666 0px 0px 10px;
  box-shadow: #929090 0px 0px 19px;
}
.marketing::before {
  content: '';
  display: block;
  position: absolute;
  top: -25px;
  left: 201px;
  width: 0;
  height: 0;
  border: 13px;
  border-style: dashed dashed solid dashed;
  border-color: transparent transparent #fff transparent;
}
.marketing li {
  font-size: 16px;
  display: inline-block;
  line-height: 1;
  float: left;
  margin: 10px;
}
.marketing li img {
  width: 72px;
  height: 72px;
}
.menu-text {
  font-size: 12px;
  width: 77px;
}
</style>
